import classNames from 'classnames/bind';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import styles from './ActivityPanel.module.css';
import { LastAttendanceData } from '../../../types/dashboard';
import PanelContainer from './PanelContainer';
import PanelHeader from './PanelHeader';
import i18n from '../../../locales/i18n';
import { formatDate } from '../../../utils/date';
import {
  LAST_ATTENDANCE,
  LAST_ATTENDANCE_EXCLUDING_TODAY,
  LAST_ATTENDANCE_DATE,
  LAST_ATTENDANCE_LOGOUT_NOTICE,
} from '../../../constants/common';
import { isMobile } from '../../../utils/util';

interface LastAttendancePanelProps {
  data: LastAttendanceData;
  isOpen: boolean;
  onClose: () => void;
}

export default function LastAttendancePanel({
  data,
  isOpen,
  onClose,
}: LastAttendancePanelProps) {
  const cx = classNames.bind(styles);

  const highlightDates = data.attendedDates.map((dateStr) => {
    const [year, month, day] = dateStr.split('-').map(Number);
    return new Date(year, month - 1, day);
  });

  const today = new Date();

  return (
    <PanelContainer isOpen={isOpen}>
      <PanelHeader
        cardId="last-date"
        title={LAST_ATTENDANCE}
        onClose={onClose}
      />
      <div className={cx('widget_content', 'atten')}>
        {isMobile || (
          <div className={cx('atten_calendar')}>
            <DatePicker
              inline
              onChange={() => {}}
              locale={i18n.language}
              dateFormat={
                i18n.language === 'ko-KR' ? 'yyyy.MM.dd' : 'MM/dd/yyyy'
              }
              highlightDates={highlightDates}
              maxDate={today}
              showDisabledMonthNavigation
              readOnly
            />
          </div>
        )}

        <div className={cx('atten_info')}>
          <div className={cx('atten_info_desc')}>
            <p>{LAST_ATTENDANCE_EXCLUDING_TODAY}</p>
            <p className={cx('atten_info_desc_date')}>
              <span className={cx('strong_date')}>
                {formatDate(data.lastDate, 5)}({data.lastWeek})
              </span>
              {LAST_ATTENDANCE_DATE}
            </p>
          </div>
          <p className={cx('subtext')}>※ {LAST_ATTENDANCE_LOGOUT_NOTICE}</p>
        </div>
      </div>
    </PanelContainer>
  );
}
